import useJwt from "@/auth/jwt/useJwt";
const axios = useJwt.axiosIns;

export async function getCustomers(skip, take, sort, filter) {
  const res = await axios.get(`${process.env.VUE_APP_API_URL}/admin/getCustomers?skip=${skip}&take=${take}&sort=${JSON.stringify(sort)}&filter=${JSON.stringify(filter)}`);
  return res.data;
}
